import { FunctionComponent } from 'react'
import { getClickableSwisslosProps } from './utils'
import ToiTeaserComponents from '@components/Teaser/Toi'

const { Swisslos } = ToiTeaserComponents

interface SporttipProps {
  url: string
}

const Sporttip: FunctionComponent<SporttipProps> = ({ url: sporttipUrl }) => {
  const clickablePropsForSwisslos = getClickableSwisslosProps({
    href: sporttipUrl,
    onClickTracking: () => {},
  })

  return <Swisslos clickablePropsForSwisslos={clickablePropsForSwisslos} />
}

export default Sporttip
